const FileUpload = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "file-upload" */ "@/app/views/main-view/_shared/_components/file-upload/file-upload.vue"
	)

const DamSireList = () => import(/* webpackPrefetch: true, webpackChunkName: "damsire-list-component"*/'@/app/views/main-view/breeders/components/breeder-dam-sire-list-component/dam-sire-list-component.vue');
const BreederPuppyList = () => import(/* webpackPrefetch: true, webpackChunkName: "puppy-list-component"*/'@/app/views/main-view/breeders/components/breeder-puppy-list-component/breeder-puppy-list-component.vue');
const ViewDamSireDetails = () => import(/* webpackPrefetch: true, webpackChunkName: "damsire-details-component"*/'@/app/views/main-view/breeders/components/breeder-dam-sire-details/breeder-dam-sire-details.vue');
const BreederMatingList = () => import(/* webpackPrefetch: true, webpackChunkName: "mating-list-component"*/'@/app/views/main-view/breeders/components/breeder-mating-list-component/breeder-mating-list-component.vue');
const LitterManagement = () => import(/* webpackPrefetch: true, webpackChunkName: litter-management-component"*/'@/app/views/main-view/breeders/components/breeder-litter-management-component/breeder-litter-management-component.vue');
//Service
import breederService from "@/app/services/main/breeder/breeder-service.js"
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"
import addressFinderAutocompleteService from "@/app/services/main/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js"

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Constants
import { STATUS_CODES, STATES, PUPPY_SELL_STATUS } from "@/app/constants/constants"

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"
import { numberFormatMixins } from "@/app/mixins/modules/number-format-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { imageUploadMixins } from "@/app/mixins/utils/image-upload-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"

// Event
import EventBus from "@/app/bus/event-bus.js"

export default {
	name: "BreederDetailsComponent",
	components: {
		FileUpload,
		DamSireList,
		BreederPuppyList,
		ViewDamSireDetails,
		BreederMatingList,
		LitterManagement
	},
	mixins: [toastMessageMixins, numberFormatMixins, tableMixins, imageUploadMixins, dateMixins],
	props: {
		breederDataId: {
			type: [String, Number],
		},
		backButtonTitle: {
			type: String,
			default: "BACK TO BREEDER MANAGEMENT",
		},
		showProfileImage: {
			type: Boolean,
			default: true,
		},
		locationType: {
			type: String,
			default: "BREEDER",
		},
		routeTo: {
			type: String,
			default: "/breeder-management",
		},
		fromBreederDetails: {
			type: Boolean,
			default: false,
		}
	},
	data() {
		return {
			isAPILoading: false,
			breederNotes: "",
			isBreederAvailable: false,
			isDetailsUpdated: false,
			backButtonLabel: this.backButtonTitle,
			stateOptions: [
				{
					value: "NSW",
					name: "New South Wales",
				},
				{
					value: "VIC",
					name: "Victoria",
				},
				{
					value: "QLD",
					name: "Queensland",
				},
				{
					value: "WA",
					name: "Western Australia",
				},
				{
					value: "SA",
					name: "South Australia",
				},
				{
					value: "TAS",
					name: "Tasmania",
				},
				{
					value: "NT",
					name: "Northern Territory",
				},
				{
					value: "ACT",
					name: "Australian Capital Territory",
				},
			],

			//Breeder
			breederId: "",
			code: "",
			state: "",
			fullname: "",
			email: "",
			mobileNumber: "",
			address: "",
			suburb: "",
			postcode: "",
			isVerifiedBreeder: false,
			imageSrc: null,
			status: "",
			companyName: "",
			notesHistory: [],

			// Image upload
			imageToCrop: "",
			imageSrc: "",
			fileBlob: null,
			isImageChanged: false,
			isBreederDeleted: false,

			// table

			statusList: [
				{ id: "AVAILABLE", name: "AVAILABLE" },
				{ id: "PENDING", name: "PENDING" },
				{ id: "SOLD", name: "SOLD" },
				{ id: "REQUEST_REFUND", name: "REQUEST FOR REFUND" },
				{ id: "CANCELED", name: "CANCELLED" },
				{ id: "REFUNDED", name: "REFUNDED" },
				{ id: "PICKED_UP", name: "PICKED UP" },
				{ id: "PENDING_PAYMENT", name: "PENDING PAYMENT" },
				{ id: "HIDDEN", name: "HIDDEN" },
			],
			// sorting
			desc: true,

			//address finder
			addressList: [],
			isAddressLoading: false,
			prevRouteTo: '',

			tabs: [
				{
					id: 'puppylist',
					label: 'Puppy List',
					component: 'BreederPuppyList',
					active: true
				},
				{
					id: 'damSireList',
					label: 'Dam/Sire List',
					component: 'DamSireList',
					active: false
				},
				{
					id: 'matingList',
					label: 'Mating List',
					component: 'BreederMatingList',
					active: false
				},
				{
					id: 'litterList',
					label: 'Litter Management',
					component: 'LitterManagement',
					active: false
				}

			],
			selectedTabComponent: 'BreederPuppyList',
		}
	},
	computed: {
		hasImage() {
			return !!this.imageSrc
		},
		getActiveTab() {
			return this.tabs.find(tab => tab.active);
		},
		shouldShowComponent() {
			const { path } = this.$route;
			return !(path.includes('/pet-purchases/puppy-selling/'))
		},

		validationRules() {
			let fields = {
				breederNotes: {},
				state: {},
				code: {},
				fullname: {},
				email: {},
				mobileNumber: {},
				address: {},
				companyName: {},
			}

			fields = vuelidateUtil.setRequiredValidation(fields, "fullname")
			fields = vuelidateUtil.setRequiredValidation(fields, "mobileNumber")
			fields = vuelidateUtil.setRequiredValidation(fields, "state")
			fields = vuelidateUtil.setRequiredValidation(fields, "code")
			fields = vuelidateUtil.setRequiredValidation(fields, "address")
			fields = vuelidateUtil.setRequiredValidation(fields, "email")
			fields = vuelidateUtil.setEmailValidation(fields, "email")
			fields = vuelidateUtil.setRequiredValidation(fields, "companyName")
			fields = vuelidateUtil.setRequiredValidation(fields, "breederNotes")

			return fields
		},

		verifiedStatus() {
			return this.isVerifiedBreeder ? "Verified Breeder" : "Unverified Breeder"
		},
	},
	watch: {
		breederNotes(val) {
			if (val != "") {
				this.$v.breederNotes.$reset()
			}
		},
		breederDataId: {
			handler(newVal, oldVal) {
				this.getBreederDetails(newVal)
			},
			immediate: true // Trigger the handler immediately on component mount
		},
		breederId(value) {
			this.isDetailsUpdated = value != this.tmpbreederId
		},
		code(value) {
			this.isDetailsUpdated = value != this.tmpcode
		},
		state(value) {
			this.isDetailsUpdated = value.name != this.tmpstate.name
		},
		fullname(value) {
			this.isDetailsUpdated = value != this.tmpfullname
		},
		email(value) {
			this.isDetailsUpdated = value != this.tmpemail
		},
		mobileNumber(value) {
			this.isDetailsUpdated = value != this.tmpmobileNumber
		},
		address(value) {
			this.isDetailsUpdated = value != this.tmpaddress
		},
		companyName(value) {
			this.isDetailsUpdated = value != this.tmpcompanyName
		},
		imageSrc(value) {
			this.isDetailsUpdated = value != this.tmpimageSrc
		},
		breederNotes(value) {
			this.isDetailsUpdated = value != this.tmpbreederNotes
		},
		fromBreederDetails(newValue) {
			if (newValue) {
				this.prevRouteTo = `/breeder-management/${this.breederDataId}/view`;
				this.backButtonLabel = "BACK TO BREEDER DETAILS";
			}
		}
	},

	async mounted() {
		this.setDefaultActiveTab();
	},
	async created() {
		if (this.locationType === "BREEDER") {
			await this.getBreederDetails(this.$route.params.id)
		}
		// const hasParams = this.$route.params.
		if (this.$route.query.actionFrom &&
			this.$route.query.actionFrom === 'payment-list'
		) {
			this.prevRouteTo = '/pet-purchases/puppy-payment'
			this.backButtonLabel = "BACK TO PUPPY PAYMENTS";
		} else {

			this.prevRouteTo = this.routeTo
		}
		this.setDefaultActiveTab();
	},
	methods: {
		setDefaultActiveTab() {
			const savedTabId = localStorage.getItem('selectedTab');
			if (savedTabId) {
				this.setActiveTab(savedTabId);
				localStorage.removeItem('selectedTab');
			} 
		},
		onBlur(field) {
			this.$v[field].$touch()
		},
		setSelectedState(e) {
			if (!e) {
				// To trigger the validation
				this.$v.state.$touch()
				return
			}
			this.state = { name: e.name, value: e.value }
		},

		getBreederDetails(breederId) {
			if (!breederId) return;

			this.isAPILoading = true

			breederService.getBreederDetailsById(breederId).then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.setFieldsData(res.data)
					this.isAPILoading = false
				} else {
					this.showAPIErrorToast("Unable to fetch puppy sell details.", res)
					this.isAPILoading = false
				}
			})
		},

		setFieldsData(data) {
			//Breeder
			this.breederId = data.id
			this.code = data.code
			this.state = data.state === "" || !data.state ? "" : { value: data.state, name: STATES[data.state] }
			this.fullname = data.name
			this.email = data.email
			this.status = data.status
			this.notesHistory = data.notesHistory
			this.postcode = data.postcode
			this.suburb = data.suburb

			let tempMobile = ""
			if (data.mobileNumber) {
				tempMobile = data.mobileNumber.split("")
				tempMobile.splice(4, 0, "-")
			}

			this.mobileNumber = tempMobile ? tempMobile.join("") : ""
			this.address = data.address
			this.isVerifiedBreeder = data.verified
			if (data.status === 'D') {
				this.isBreederDeleted = true;
				this.breederNotes = "Breeder is deleted";
			}
			else if (data.reason) {
				this.breederNotes = data.reason;
			}
			else if (data.notesHistory && data.notesHistory.length > 0) {
				this.breederNotes = data.notesHistory[0].note
			}
			else {
				this.breederNotes = "";
			}

			this.imageSrc = data.imageUrl
			this.companyName = data.companyName
			//Temp Data for comparison
			this.tmpbreederId = data.id
			this.tmpemail = data.email
			this.tmpstate = data.state === "" || !data.state ? "" : { value: data.state, name: STATES[data.state] }
			this.tmpmobileNumber = tempMobile ? tempMobile.join("") : ""
			this.tmpfullname = data.name
			this.tmpaddress = data.address
			this.tmpcode = data.code
			this.tmpcompanyName = data.companyName
			this.tmpimageSrc = data.imageUrl
			this.tmpbreederNotes = data.reason ? data.reason : ""
		},

		updateBreederDetails() {
			this.$v.$touch()

			if (this.$v.$invalid) {
				return
			}
			this.isEditAPILoading = true
			const details = {
				requestDetails: {
					breeder: {
						id: this.breederId,
						code: this.code,
						state: this.state.value,
						name: this.fullname,
						email: this.email,
						mobile: this.mobileNumber.replace("-", ""),
						address: this.address,
						postcode: this.postcode,
						suburb: this.suburb,
						companyName: this.companyName,
						reason: this.breederNotes,
					},
					requestType: "UPDATE",
					isDetailsUpdated: true,
				},
				breederImg: this.fileBlob ? this.fileBlob[0] : "",
			}

			breederService.updateBreederDetails(details).then(async (res) => {
				if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					this.showCustomSuccessToast(null, `Breeder details has been updated!`)
					this.isEditAPILoading = false
					const id = this.locationType === "BREEDER" ? this.$route.params.id : this.breederDataId
					this.getBreederDetails(id)
					this.$emit("refreshPage")
				} else {
					this.showAPIErrorToast("Unable to update breeder details.", res)
					this.isEditAPILoading = false
				}
			})
		},

		approvedDeclinedBreederDetails(status) {
			if (status === "A") {
				this.$v.$touch()

				if (this.$v.$invalid) {
					return
				}
			}

			if (status === "DECLINED" && this.breederNotes === "") {
				this.$v.breederNotes.$touch()
				return
			}

			this.$v.breederNotes.$reset()
			const statusText = status === "A" ? "APPROVE" : "DECLINE"

			this.$swal({
				title: `${statusText} REQUEST`,
				html: `<strong style="color: ${status === "A" ? "#1e7e34" : "#f5365c"
					}">${statusText}</strong> breeder details of ${this.fullname}?`,
				confirmButtonText: statusText,
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				if (result.value) {
					this.isAPILoading = true
					const details = {
						id: this.breederId,
						status: status,
						reason: this.breederNotes,
						code: this.code,
						state: this.state.value,
						name: this.fullname,
						email: this.email,
						mobile: this.mobileNumber.replace("-", ""),
						address: this.address,
						companyName: this.companyName,
					}

					breederService.approvedDeclinedBreeder(details).then(async (res) => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast(null, `Breeder details has been ${statusText.toLowerCase()}d.`)
							this.isAPILoading = false
							const id = this.locationType === "BREEDER" ? this.$route.params.id : this.breederDataId
							this.getBreederDetails(id)
							this.$emit("refreshPage")
							EventBus.$emit("getPendingBreedersCount")
						} else {
							this.showAPIErrorToast("Unable to approved or declined puppy details.", res)
							this.isAPILoading = false
						}
					})
				}
			})
		},

		mobileNumberFormat(value, isBreeder) {
			this.mobileNumberIsValid = true

			let regexp = /^\d+$/
			let updateData = regexp.test(value.charAt(value.length - 1))
			const val = value.replace("-", "")

			if (updateData && val.length <= 10) {
				if (isBreeder) {
					this.mobileNumber = val.replace(/(....)(......)/g, "$1-$2")
				} else {
					this.fields.mobileNumber = val.replace(/(....)(......)/g, "$1-$2")
				}
			} else {
				if (isBreeder) {
					this.mobileNumber = !updateData ? val.slice(0, -1) : this.mobileNumber
				} else {
					this.fields.mobileNumber = !updateData ? val.slice(0, -1) : this.fields.mobileNumber
				}
			}
		},
		hasProductImage(productImage) {
			let image = require("@/assets/images/temporary/product-image.png")

			if (productImage) {
				image = productImage
			}

			return image
		},
		async updatePuppySellStatus(puppySellId, buyerId, status) {
			try {
				const modalConfirmationRes = await this.$swal({
					titleText: `Mark Puppy for Sale as ${PUPPY_SELL_STATUS[status]}`,
					html: `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to update the puppy for sale status to <strong style='color: #ff801e'>${PUPPY_SELL_STATUS[status]}</strong>?</p>`,
					confirmButtonText: "Confirm",
					showCancelButton: true,
					cancelButtonText: "Cancel",
					reverseButtons: true,
					showCloseButton: true
				});

				if (modalConfirmationRes.isConfirmed) {
					this.isAPILoading = true;

					const details = {
						buyerId,
						status,
					};

					const response = await puppySellService.updatePuppyDetailsStatus(puppySellId, details);

					if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.getTableContent()
						this.showCustomSuccessToast(
							`Successfully updated Puppy selling status to ${PUPPY_SELL_STATUS[status]}`
						)
					} else {
						const errorMessage = response.data.errors[0].message;

						if (response.status === STATUS_CODES.BAD_REQUEST) {
							this.showAPIErrorToast(errorMessage, response);
						}
						else {
							this.showGenericErrorToast();
						}
					}

					this.isAPILoading = false
				}
			}
			catch (err) {
				this.showGenericErrorToast();
			}
		},
		reactivateDeactivateBreeder(status) {
			if (status === "DEACTIVATE" && this.breederNotes === "") {
				this.$v.breederNotes.$touch()
				return
			}

			if (this.status === "FOR_REACTIVATION") {
				this.breederNotes = "Admin Reactivate Breeder"
			}

			if (status === "DEACTIVATE") {
				this.$swal({
					title: `${status} REQUEST`,
					html: `<strong style="color: ${status === "REACTIVATE" ? "#1e7e34" : "#f5365c"
						}">${status}</strong> breeder details of ${this.fullname}?`,
					confirmButtonText: status,
					showCancelButton: true,
					cancelButtonText: "Cancel",
					reverseButtons: true,
					showCloseButton: true,
				}).then((result) => {
					if (result.value) {
						this.reactivateDeactivateBreederApiCall(status)
					}
				})
			} else {
				this.reactivateDeactivateBreederApiCall(status)
			}
		},

		async reactivateDeactivateBreederApiCall(status) {
			this.isAPILoading = true

			this.$v.breederNotes.$reset()
			const details = {
				id: this.breederId,
				status,
				note: this.breederNotes,
			}
			breederService.reactivateDeactivateBreeder(details).then(async (response) => {
				if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					await this.getBreederDetails(this.$route.params.id)
					this.showCustomSuccessToast(`Successfully ${status.toLowerCase()}d the breeder`)
				} else {
					this.showAPIErrorToast(response.data.errors[0].message, response)
				}
				this.isAPILoading = false
			})

		},
		async onUploadImage(event) {
			let valid = this.validateImage(event.target.files[0])

			// compress image if more than 2mb
			const file = await this.compressImage(event.target.files[0])

			// do nothing when user cancels Upload
			if (!valid) {
				// reset uploader
				this.$refs.uploader.value = ""
				return
			}

			this.fileBlob = [file]

			// show preview of pet image
			let reader = new FileReader()
			reader.onload = () => {
				this.imageToCrop = reader.result
				this.$refs.modalFileUpload.show()
			}

			reader.readAsDataURL(file)
		},

		setImageCrop({ image, blob }) {
			this.isImageChanged = true
			this.imageSrc = image
			this.fileBlob = blob
		},

		clearFileInput(event) {
			event.target.value = ""
		},

		findAddress(address) {
			if (address) {
				this.isAddressLoading = true

				this.delayTyping(() => {
					this.getAutocompleteAddress(address)
				})
			}
		},

		getAutocompleteAddress(address) {
			addressFinderAutocompleteService
				.getAutocompleteAddress(address)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.addressList = res.data.completions.map((item) => {
							let tempAddress = item.full_address
							item.displayAddress = tempAddress
							item.label = item.id
							return item
						})
						this.isAddressLoading = false
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder()
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res)
						this.isAddressLoading = false
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAddressLoading = false
				})
		},

		async getAddressMetaData(address) {
			addressFinderAutocompleteService
				.getAddressMetaData(address.id)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const { locality_name, postcode, full_address } = res.data
						this.address = full_address
						this.postcode = postcode
						this.suburb = locality_name
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder()
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res)
						this.isAddressLoading = false
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAddressLoading = false
				})
		},
		async setSelectedAddress() {
			this.$v.address.$touch()

			if (this.address) {
				await this.getAddressMetaData(this.address)
			}
		},
		deletePuppy(puppySellId) {
			this.$swal({
				titleText: `Delete Puppy`,
				html: `<p style='color: #ff801e; margin: .75rem 0 .25rem 0;'>Are you sure you want to delete this puppy?</p>`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				if (result.value) {
					this.isAPILoading = true

					puppySellService.putDeletePuppyToSell(puppySellId).then((response) => {
						if (response.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.getTableContent()
							this.showCustomSuccessToast(`Successfully deleted this puppy.`)
						} else {
							this.showAPIErrorToast(response.data.errors[0].message, response)
						}
						this.isAPILoading = false
					})
				}
			})
		},

		deleteBreeder() {
			const id = this.$route.params.id
			// show modal confirmation
			this.$swal({
				title: `Are you sure you want to delete ${this.fullname}?`,
				text: `You won't be able to revert this action.`,
				confirmButtonText: "Delete",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				confirmButtonColor: "#dd3333 !important",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {
				if (result.value) {
					// API call for delete
					breederService.deleteBreeder(id).then((res) => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast("Deleted!", `${this.fullname} has been deleted!`)
							// refresh table with filter
							this.$router.push("/breeder-management")
						} else {
							this.showAPIErrorToast(`Unable to delete ${this.fullname}`, res)
						}
					})
				}
			})
		},

		//NEW
		setActiveTab(selectedTab) {
			this.tabs = this.tabs.map(tab => {
				// set the selected tab to active
				if (tab.id === selectedTab) {
					tab.active = true;
					this.selectedTabComponent = tab.component;
					localStorage.setItem('selectedTab', selectedTab);
				} else {
					tab.active = false;
				}
				return tab;
			});
		},
	},
	// third party libraries
	validations() {
		return this.validationRules
	},
}
